export const FUNCTION_MARKER = 'ƒ';
export const ACCESSOR_MARKER = '∂';
export const ACCESSOR_GET_POINTER = '_get_';
export const ACCESSOR_SET_POINTER = '_set_';
export const WITH_ACCESSOR_INDICATOR = '+';
export const NO_ACCESSOR_INDICATOR = '-';
export const PATH_SEPARATOR = '·';
export const ENCODER_MARKER = '×';
export const ENCODER_EMPTY_MARKER = '°';

export const extractPointer = (pointer: string) =>
  pointer[0] === ENCODER_MARKER ? '' : pointer;

export const isFinalNode = (instance: unknown) => {
  return (
    instance === null ||
    typeof instance === 'undefined' ||
    typeof instance === 'symbol' ||
    typeof instance === 'number' ||
    typeof instance === 'boolean' ||
    typeof instance === 'function' ||
    typeof instance === 'string'
  );
};

export const isSerializableType = (instance: unknown) => {
  return (
    !!instance &&
    typeof instance === 'object' &&
    !Array.isArray(instance) &&
    !(instance instanceof Date) &&
    !(instance instanceof Set) &&
    !(instance instanceof Map)
  );
};

export const beautifyPath = (path: string) =>
  beautifyBreadcrumbs(path.split(PATH_SEPARATOR));
export const beautifyBreadcrumbs = (breadcrumbs: string[]) =>
  breadcrumbs.map(extractPointer).filter(Boolean).join('.');
